// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modals-container p{margin:25px 0;font-size:16px}.modals-container .modal-image{width:250px;margin:20px 0}", ""]);
// Exports
module.exports = exports;
